(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["admin/main/includes/_school_select.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "sites")) < 51) {
output += "\n    <div class=\"comet-form__select\">\n        <select class=\"comet-form__select-input\" id=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "school_field_id"), env.opts.autoescape);
output += "\" name=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "school_field_name"), env.opts.autoescape);
output += "\">\n            <option class=\"comet-form__select-option\" value=\"\">Select School</option>\n            ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "sites");
if(t_3) {t_3 = runtime.fromIterator(t_3);
var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("site", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n                <option class=\"comet-form__select-option\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"name"), env.opts.autoescape);
output += "</option>\n            ";
;
}
}
frame = frame.pop();
output += "\n        </select>\n        <div class=\"comet-form__select-visual-wrap\"></div>\n        <span class=\"comet-form__select-open-indicator\">\n            <svg class=\"comet-form__select-open-icon\" aria-hidden=\"true\" focusable=\"false\">\n                <use xlink:href=\"";
output += runtime.suppressValue((lineno = 11, colno = 47, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "edde_static"), "edde_static", context, ["comet/2.x/comet.svg#caret-down"])), env.opts.autoescape);
output += "\"></use>\n            </svg>\n        </span>\n    </div>\n";
;
}
else {
output += "\n    <div class=\"comet-form__select\">\n        <select class=\"js-admin-select2--site-search\" name=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "school_field_name"), env.opts.autoescape);
output += "\" id=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "school_field_id"), env.opts.autoescape);
output += "\"></select>\n        <span class=\"comet-form__select-open-indicator\">\n            <svg class=\"comet-form__select-open-icon\" aria-hidden=\"true\" focusable=\"false\">\n                <use xlink:href=\"";
output += runtime.suppressValue((lineno = 20, colno = 47, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "edde_static"), "edde_static", context, ["comet/2.x/comet.svg#caret-down"])), env.opts.autoescape);
output += "\"></use>\n            </svg>\n        </span>\n    </div>\n";
;
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

define("apps/admin/templates/includes/_school_select", function(){});

